import { Icon } from '@iconify/react/dist/iconify.js';
import { GiSteeringWheel } from 'react-icons/gi';
import { TbCash } from 'react-icons/tb';
import { NavLink } from 'react-router-dom';

const getDifference = (current = 0, previous = 0) => {
    const diff = current - previous;
    const isPositive = diff > 0;
    const isZero = diff === 0;
    const sign = diff > 0 ? '+' : '';
    const badgeClass = isZero
        ? 'bg-secondary px-1 rounded-2 text-white text-sm fw-semibold'
        : isPositive
            ? 'bg-success-focus px-1 rounded-2 text-success-main text-sm fw-semibold'
            : 'bg-danger-subtle px-1 rounded-2 text-danger text-sm fw-semibold';

    return {
        text: `${sign}${diff}`,
        badgeClass,
    };
};

const UnitCountTwo = ({ states }) => {
    const current = states?.calculated_info || {};
    const previous = states?.previous_info || {};

    const metrics = [
        {
            link: "/users-list",
            label: 'Total Users',
            value: current.total_users,
            previous: previous.total_users,
            icon: <Icon icon="mingcute:user-follow-fill" className="icon" />,
            bg: 'bg-primary-600',
        },
        {
            link: "/users-list",
            label: 'Online Users',
            value: current.total_online_users,
            previous: previous.total_online_users,
            icon: <Icon icon="mingcute:user-follow-fill" className="icon" />,
            bg: 'bg-success-main',
        },
        {
            link: "/users-list",
            label: 'Offline Users',
            value: current.total_offline_users,
            previous: previous.total_offline_users,
            icon: <Icon icon="mingcute:user-follow-fill" className="icon" />,
            bg: 'bg-secondary',
        },
        {
            link: "/sales-history",
            label: 'Total Sales',
            value: current.total_sales,
            previous: previous.total_sales,
            isCurrency: true,
            icon: <Icon icon="streamline:bag-dollar-solid" className="icon" />,
            bg: 'bg-cyan',
        },
        {
            link: "/leads",
            label: 'Leads',
            value: current.total_leads,
            previous: previous.total_leads,
            icon: <Icon icon="mdi:leads" className="icon" />,
            bg: 'bg-pink',
        },
        {
            link: "/tickets",
            label: 'Tickets',
            value: current.total_tickets,
            previous: previous.total_tickets,
            icon: <Icon icon="mdi:message-text" className="icon" />,
            bg: 'bg-purple',
        },
        {
            link: "/rides",
            label: 'Bookings',
            value: current.total_bookings,
            previous: previous.total_bookings,
            icon: <GiSteeringWheel className="menu-icon" size="24" />,
            bg: 'bg-purple',
        },
        {
            link: "/sales-history",
            label: 'Total Revenue',
            value: current.total_revenue,
            previous: previous.total_revenue,
            isCurrency: true,
            icon: <TbCash className="menu-icon" size="22" />,
            bg: 'bg-pink',
        },
    ];

    return (
        <div className="col-xxl-12">
            <div className="row gy-4">
                {metrics.map((item, index) => {
                    const { text, badgeClass } = getDifference(item.value, item.previous);
                    return (
                        <div className="col-xxl-3 col-sm-4" key={index}>
                            <NavLink to={item.link} className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                                <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div className="d-flex align-items-center gap-2">
                                            <div>
                                                <span className="mb-2 fw-semibold text-secondary-light text-md">
                                                    {item.label}
                                                </span>
                                                <h6 className="fw-semibold">
                                                    {item.isCurrency ? '₹ ' : ''}
                                                    {item.value || 0}
                                                </h6>
                                            </div>
                                        </div>
                                        <span
                                            className={`mb-0 w-48-px h-48-px ${item.bg} text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6`}
                                        >
                                            {item.icon}
                                        </span>
                                    </div>
                                    <p className="text-sm mb-0">
                                        <span className={badgeClass}>
                                            {text}
                                        </span>{' '}
                                        vs last period
                                    </p>
                                </div>
                            </NavLink>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UnitCountTwo;
